<template>
<div id="app"
     class='full-size'>
      <img class='logo'
           src='/static/logo.png' />

    <transition v-on:enter="enter"
                v-on:after-enter="afterEnter"
                v-on:leave="leave"
                v-bind:css="false">
       <router-view></router-view>
    </transition>
    <div class='footer'>
       <div class='flex'>
          <div class='col'>

             <p class='bold'><a v-bind:class="classObject"
                   class='underline-link'
                   href='https://www.google.rs/maps/place/Carrer+de+Muntaner,+267,+08021+Barcelona,+Spain/@41.3956259,2.146356,18.05z/data=!4m13!1m7!3m6!1s0x12a4a29dcd475137:0x41e01a4da147cc85!2sCarrer+de+Muntaner,+267,+08021+Barcelona,+Spain!3b1!8m2!3d41.3955925!4d2.1474064!3m4!1s0x12a4a29dcd475137:0x41e01a4da147cc85!8m2!3d41.3955925!4d2.1474064?hl=en'

                   target='_blank'>Klimentská 24, Praha 1, 110 00 Czech Republic</a></p>
          </div>
          <div class='col'>
             <p class='bold t-center'><a v-bind:class="classObject"
                   class='underline-link'
                   href='mailto:contact@jtw.cz'>contact@jtw.cz</a></p>
          </div>
          <div class='col'>
             <p class='bold t-right'><a v-bind:class="classObject"
                   class='underline-link'
                   href='tel:+420777676708'>(420) 777 676 708</a></p>
          </div>
       </div>
    </div>

</div>

</template>

<script>
import 'gsap';
import Transition from '@/mixins/transition';

export default {
    name: 'app',
    components: {
    },

    events: {
    },

    mounted: function()  {},

    computed: {
        isHome()  {
            let pageName = this.$store.state.route.name
            return pageName === 'Home'
        },

        classObject()  {
            return {
                'wht-link': !this.isHome,
                'dark-link': !this.isHome
            }
        }
    },

    created()  {
        var self = this
        window.addEventListener('resize', function()  {
            self.onResize()
        })

        let mobile = this.detectMobile();
        this.$store.dispatch('app/SET_MOBILE', mobile)
    },

    mixins: [

        Transition
    ],

    methods: {
        onResize()  {
          this.$store.dispatch('app/SET_STATE', {
            pageHeight: window.innerHeight
          });

          this.$store.dispatch('app/SET_STATE', {
            pageWidth: window.innerWidth
          });
        },

        detectMobile()  {
            let a = navigator.userAgent || navigator.vendor || window.opera;

            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
                return true;
            }
        }
    }
}

</script>

<style lang="scss">
@font-face {
   font-family: 'Gotham-Book';
   src: url('/static/fonts/Gotham-Book.eot');
   src: url('/static/fonts/Gotham-Book.eot?#iefix') format('embedded-opentype'), url('/static/fonts/Gotham-Book.woff') format('woff'), url('/static/fonts/Gotham-Book.ttf') format('truetype'), url('/static/fonts/Gotham-Book.svg#d1e00a8fb1fd9b428ab6b90409479fde') format('svg');
   font-style: normal;
   font-weight: 700;
}

@font-face {
   font-family: 'Gotham-Bold';
   src: url('/static/fonts/Gotham-Bold.eot');
   src: url('/static/fonts/Gotham-Bold.eot?#iefix') format('embedded-opentype'), url('/static/fonts/Gotham-Bold.woff') format('woff'), url('/static/fonts/Gotham-Bold.ttf') format('truetype'), url('/static/fonts/Gotham-Bold.svg#d1e00a8fb1fd9b428ab6b90409479fde') format('svg');
   font-style: normal;
   font-weight: 700;
}

#app {
   font-family: 'Gotham-Bold';
   -webkit-font-smoothing: antialiased;
   -moz-osx-font-smoothing: grayscale;
   color: #fff;
}


.logo{
  position: fixed;
  width: 16vw;
  left: 4vw;
  top: 4vw;
  z-index: 2;  
}

body,
html {
   height: 100%;
   margin: 0;
   background: #f3e9d5;
}

a {
   color: black;
   text-decoration: none;
}

.underline-link {
   position: relative;
   transition: color 1s;
   font-size: 14px;
   @media (min-width: 768px) {
      font-size: 1.4rem;
   }
   @media (min-width: 992px) {
      font-size: 1rem;
   }
   @media (min-width: 1200px) {
      font-size: 1vw;
   }
   &:after {
      content: '';
      display: block;
      position: absolute;
      top: 100%;
      width: 100%;
      height: 2px;
      background: black;
      left: 0;
      margin-top: 0.3em;
      transform: translateY(6px);
      opacity: 0;
      transition: all 0.4s;
   }
   &:hover {
      &:after {
         transform: translateY(0);
         opacity: 1;
      }
   }
}

.wht-link {
   &:after {
      background: #fff;
   }
}

.dark-link {
   color: #140d0f;
   &:after {
      background: #140d0f;
   }
}

.footer {
   position: fixed;
   bottom: 20px;
   width: 100%;
   left: 0;
   padding: 0 32px;
   font-weight: bold;
   color: black;
   @media (min-width: 992px) {
      padding: 0 4vw;
      bottom: 1.5vw;
   }
   .flex {
      flex-direction: column;
      @media (min-width: 768px) {
         flex-direction: column;
      }
      @media (min-width: 992px) {
         flex-direction: row;
      }
      @media (min-width: 1200px) {
         flex-direction: row;
      }
      p {
         margin: 0.4em 0;
         @media (max-width: 991px) {
            text-align: right;
         }
      }
   }
}




.col4 {
   -webkit-box-flex: 0;
   -ms-flex: 0 0 100%;
   flex: 0 0 100%;
   max-width: 100%;

    @media screen and (min-width: 767px) {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 100%;
      flex: 0 0 100%;
      max-width: 100%;
   }

   @media screen and (min-width: 996px) {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 33%;
      flex: 0 0 33%;
      max-width: 33%;
   }

  
}

.col6 {
   -webkit-box-flex: 0;
   -ms-flex: 0 0 100%;
   flex: 0 0 100%;
   max-width: 100%;

   @media screen and (min-width: 767px) {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 100%;
      flex: 0 0 100%;
      max-width: 100%;
   }

   @media screen and (min-width: 996px) {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 50%;
      flex: 0 0 50%;
      max-width: 50%;
   }
}

.absolute{
  position: absolute;
}

.inline-block {
   display: inline-block;
}

.space-between {
   justify-content: space-between;
   padding-top: 3%;
}

.relative {
   position: relative;
}

.full-size {
   width: 100%;
   height: 100%;
}

.flex {
   display: flex;
   flex-wrap: wrap;
}

.white-bg {
   background: white;
}

.center-align {
   justify-content: center;
}

.borders-wrapper {
   padding: 2% 0;
}

div {
   box-sizing: border-box;
}

.t-right {
   text-align: right;
}

.t-center {
   text-align: center;
}

.transitioning-out {
   position: absolute; // width: 100%;
   height: 100%;
   display: block;
}

.btn {}

.col {
   flex-grow: 1;
   flex-basis: 0;
   max-width: 100%;
   box-sizing: border-box;
   /*flex-grow: 0;*/
   flex-shrink: 0;
   padding-right: 0;
   padding-left: 0;
   z-index: 1;
   &--small {
      @media screen and (min-width: 768px) {
         flex-basis: 10.5%;
         max-width: 10.5%;
      }
   }
}

.decor {
   &:after,
   &:before {
      width: 3px;
      height: 16px;
      position: absolute;
      background: black;
      content: '';
      display: none;
      @media screen and (min-width: 768px) {
         display: block;
      }
   }
   &:after {
      top: 0;
      right: -2px;
   }
   &:before {
      bottom: 0;
      right: -2px;
   }
}

.column-direction {
   flex-direction: column;
}

.page {
   padding: 0 32px;
   // display: flex;
   display: fixed;
   overflow: auto;

   @media (min-width: 992px) {
      padding: 0 4vw;
   }
}

.hidden-xs {
   @media screen and (max-width: 767px) {
      display: none;
   }
}

.inner-wrapper {
   padding: 50px 0;
}

.main-wrapper {
   position: relative;
   overflow: hidden;
}

h1,
h2 {
   margin: 0;
}
</style>



// WEBPACK FOOTER //
// App.vue?1688ba9e